import React from 'react';

import { View } from '@vkontakte/vkui';

import { DesktopAboutUsPanel } from './panels/DesktopAboutUsPanel';
import { DesktopAfterUserChoosePanel } from './panels/DesktopAfterUserChoosePanel';
import { DesktopUserEnteringPanel } from './panels/DesktopUserEnteringPanel';
import { PredictionPanel } from './panels/PredictionPanel';
import { ResultPanel } from './panels/ResultPanel';
import { SearchFriendPanel } from './panels/SearchFriendPanel';
import { PredictionViewProps } from './types';
import { PANEL } from '../../constants/Panel';


export const PredictionView: React.FC<PredictionViewProps> = ({ id, activePanel }) => {
  return (
    <View id={id} activePanel={activePanel}>
      <PredictionPanel id={PANEL.PREDICTION} />
      <SearchFriendPanel id={PANEL.SEARCH_FRIEND} />
      <ResultPanel id={PANEL.RESULT} />
      <DesktopAboutUsPanel id={PANEL.ABOUT_US} />
      <DesktopUserEnteringPanel id={PANEL.USER_ENTERING} />
      <DesktopAfterUserChoosePanel id={PANEL.AFTER_USER_CHOOSE} />
    </View>
  );
};
